// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__MUIic","title":"InfoRow_title__1Pj-k"};